var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyLogoLg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9993 6.30047L3.51828 1.44959C2.63924 1.07819 1.66602 1.72352 1.66602 2.6778V23.3337C1.66602 24.07 2.26297 24.667 2.99935 24.667H26.9993C27.7357 24.667 28.3327 24.07 28.3327 23.3337V7.18458C28.3327 6.64873 28.0119 6.16493 27.5183 5.95638L16.8516 1.44959C15.9726 1.07819 14.9993 1.72352 14.9993 2.6778V6.30047ZM14.9993 6.30047V10.5299M6.11046 18.667H8.33268M10.5549 18.667H12.7771",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 2.13333,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogoLg);
export default __webpack_public_path__ + "static/media/company-logo-lg.475d658a1f098bb6c4d09fe8b1888473.svg";
export { ForwardRef as ReactComponent };